import { useState } from "react";
import { st } from "../../styles.js";
import { BuzerIcon } from "../../BuzerIcons";
import { SectionHeader, Caption, Tag, List, ListRow, ProgressBar } from "../../components/ui/ds";
import { pastVerb } from "../../lib/format";

// v33 §6.2 — KOLÁ v jednej rozbaľovacej sekcii (rozhodnutie majiteľky 2026-09-03: detail modal
// bol príliš dlhý). Zbalené = hlavička s poradím kola a jedným číslom, ktoré treba prekonať —
// to je celá motivácia. Rozbalené = lišta s tieňom, rekord a história všetkých kôl; pri 3. a
// ďalšom kole je história jediné miesto, kde vidno staršie kolá než to predchádzajúce.
export function RoundSection({ data, fmtVal }) {
  const [open, setOpen] = useState(false);
  const target = data.target || 0;
  const now = data.value || 0;
  const left = Math.max(0, Math.round(target - now));
  return (
    <div style={{ marginTop: 18 }}>
      <SectionHeader label={`${data.round_no}. kolo`} icon="undo" onClick={() => setOpen(!open)}
        style={{ margin: "2px 2px 10px" }}
        trailing={(
          <span style={{ display: "inline-flex", alignItems: "center", gap: 7 }}>
            <span style={{ ...st.taskDesc, fontFamily: "var(--ff-mono)", fontWeight: 700 }}>
              {data.beaten ? "prekonané" : (target ? "chýba " + fmtVal(left) : "")}
            </span>
            <BuzerIcon name="chevron" size={15} color="var(--neutral-text-subtle)"
              style={{ transform: open ? "rotate(90deg)" : "none", transition: "transform .18s" }} />
          </span>
        )} />
      {target > 0 && <RoundTargetBar data={data} fmtVal={fmtVal} />}
      {open && (
        <>
          <Caption variant="note" style={{ marginTop: 8 }}>
            Nadväzuje na {data.prev.name}
            {data.prev.rank ? ` · vtedy ${data.prev.rank}. miesto` : ""}
            {data.pct && data.prev.completions != null
              ? ` · vtedy ${data.prev.completions} z ${data.prev.expected}` : ""}.
          </Caption>
          {data.record && (
            <Caption variant="note" style={{ marginTop: 4 }}>
              Tvoj rekord v tejto súťaži: {fmtVal(data.record.value)} ({data.record.name}).
            </Caption>
          )}
          {(data.rounds || []).length > 1 && (
            <List style={{ marginTop: 10 }}>
              {data.rounds.map((r) => (
                <ListRow key={r.id} lead={<span style={{ ...st.taskDesc, fontFamily: "var(--ff-mono)" }}>{r.started ? r.started.slice(5).replace("-", ".") + "." : ""}</span>}
                  title={r.name}
                  trailing={(
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                      <span style={{ fontFamily: "var(--ff-mono)", fontWeight: 700, fontSize: 13 }}>{fmtVal(r.value)}</span>
                      {r.current && <Tag tone="brand" size="xs">teraz</Tag>}
                    </span>
                  )} />
              ))}
            </List>
          )}
        </>
      )}
    </div>
  );
}

// Lišta „na prekonanie": kde som (výplň), kde bolo minulé ja v rovnakom bode obdobia (ghost)
// a čo treba prekonať (marker).
function RoundTargetBar({ data, fmtVal }) {
  const target = data.target || 0;
  const rec = data.record && data.record.value;
  const top = Math.max(target, rec || 0, data.value || 0) || 1;
  const pct = (v) => (v == null ? null : (v / top) * 100);
  const now = data.value || 0;
  const sh = data.shadow;
  const diff = sh == null ? null : Math.round(now - sh);
  let note;
  if (data.beaten) {
    note = <>Prekonané! Minulé kolo je za tebou o <b>{fmtVal(Math.round(now - target))}</b>. 🔥</>;
  } else if (diff == null) {
    note = <>Na prekonanie minulého kola potrebuješ <b>{fmtVal(Math.round(target - now))}</b>.</>;
  } else if (diff >= 0) {
    note = <>Minule si v tomto bode {pastVerb("mal")} <b>{fmtVal(Math.round(sh))}</b> — máš náskok {fmtVal(diff)}.</>;
  } else {
    note = <>Minule si v tomto bode {pastVerb("mal")} <b>{fmtVal(Math.round(sh))}</b> — chýba ti {fmtVal(-diff)}.</>;
  }
  return (
    <>
      <ProgressBar pct={pct(now)} ghost={pct(sh)} marker={pct(target)} />
      <Caption variant="note" style={{ marginTop: 8 }}>{note}</Caption>
    </>
  );
}
